import { HttpErrorResponse } from "@angular/common/http";

import { ExtendedGfhAccount } from "@core/models/extended-gfh-account.model";
import { PendingIban } from "@core/models/pending-iban.model";
import { PendingNav } from "@core/models/pending-nav.model";
import { ProductVersions } from "@core/models/product-versions.model";
import { TableSorting, TPagination } from "@custom-types/sorting";
import { createAction, props } from "@ngrx/store";

export const DASHBOARD_ACTION_FAILURE = createAction(
  "[Dashboard] Dashboard Action Failure",
  props<{ error: HttpErrorResponse }>()
);

export const SET_DASHBOARD_LOADING = createAction(
  "[Dashboard] Set Dashboard Loading",
  props<{ loading: boolean }>()
);

export const LOAD_PENDING_NAV = createAction("[Dashboard] Load Pending Nav");

export const SET_PENDING_NAV = createAction(
  "[Dashboard] Set Pending Nav",
  props<{ pendingNavList: Array<PendingNav> }>()
);

export const LOAD_PRODUCT_VERSION_CHANGED = createAction(
  "[Dashboard] Load Product Version Changed",
  props<{ pagination?: Partial<TPagination> }>()
);

export const SET_PRODUCT_VERSION_CHANGED_LIST = createAction(
  "[Dashboard] Set Product Version Changed List",
  props<{ productVersionList: Array<ExtendedGfhAccount> }>()
);

export const LOAD_SELF_APPROVAL_TABLE = createAction(
  "[Dashboard] Load Self Approval Table",
  props<{
    canApprove: boolean;
    sorting?: TableSorting;
  }>()
);

export const SET_SELF_APPROVAL_TABLE_LOADING = createAction(
  "[Dashboard] Set Self Approval Table Loading",
  props<{ selfApprovalLoading: boolean }>()
);

export const SET_SELF_APPROVAL_TABLE = createAction(
  "[Dashboard] Set Self Approval Table",
  props<{ selfApprovalList: Array<PendingIban> }>()
);

export const LOAD_APPROVAL_TABLE = createAction(
  "[Dashboard] Load Approval Table",
  props<{
    canApprove: boolean;
    sorting?: TableSorting;
  }>()
);

export const SET_APPROVAL_TABLE_LOADING = createAction(
  "[Dashboard] Set Approval Table Loading",
  props<{ approvalLoading: boolean }>()
);

export const SET_APPROVAL_TABLE = createAction(
  "[Dashboard] Set Approval Table",
  props<{ approvalList: Array<PendingIban> }>()
);

export const LOAD_LAST_SEVEN_DAYS_APPROVED_TABLE = createAction(
  "[Dashboard] Load Last Seven Days Approved Table",
  props<{ sorting?: TableSorting }>()
);

export const SET_LAST_SEVEN_DAYS_APPROVED_TABLE_LOADING = createAction(
  "[Dashboard] Set Last Seven Days Approved Table Loading",
  props<{ lastSevenDaysLoading: boolean }>()
);

export const SET_LAST_SEVEN_DAYS_APPROVED_TABLE = createAction(
  "[Dashboard] Set Last Seven Days Approved Table",
  props<{ lastSevenDaysList: Array<PendingIban> }>()
);

export const APPROVE_OR_DECLINE_TASK = createAction(
  "[Dashboard] Approve or Decline Task",
  props<{ path: number; id: string; decision: boolean }>()
);

export const LOAD_PRODUCT_VERSIONS = createAction(
  "[Dashboard] Load Product Versions",
  props<{ id: string }>()
);

export const SET_PRODUCT_VERSIONS = createAction(
  "[Dashboard] Set Product Versions",
  props<{ productVersions: ProductVersions }>()
);

export const SAVE_ACCOUNT_COST_RULES = createAction(
  "[Dashboard] Save Account Cost Rules",
  props<{ gfhAccountInformation: Partial<ExtendedGfhAccount> }>()
);

export const SET_PRODUCT_VERSION_CHANGED_LENGTH = createAction(
  "[Dashboard] Set Product Version Changed Length",
  props<{ length: number }>()
);

export const SET_PRODUCT_VERSION_CHANGED_PAGINATION = createAction(
  "[Dashboard] Set Product Version Changed Pagination",
  props<{ pagination: Partial<TPagination> | undefined }>()
);
